import { Outlet, ScrollRestoration, useLocation } from 'react-router';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToHash } from './components/ScrollToHash';
import { ScrollToTop } from './components/ScrollToTop';
import { GoogleOneTap } from './components/auth/GoogleOneTap';
import { AskNameDialog } from './components/auth/AskNameDialog';
import { ChatPopupHost } from '../chat/components/ChatPopupHost';

// Full-screen pages that behave like an app screen — no footer under them.
// Tabs of the mobile bottom nav that should feel like app screens.
// /listings: on a phone the search results end with the listings themselves
// (and pagination) — no site footer to scroll through.
const APP_TAB_ROUTES = ['/favorites', '/listings'];

const FULL_SCREEN_ROUTES = ['/map-page', '/kyrgyz-map', '/turaq-kg-genplan-bishkek2050'];

// Like the browser itself: a reload or back/forward into the site keeps the
// position, a fresh open (link, typed URL) starts at the top.
const FIRST_LOAD_KEY = (() => {
  try {
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    return nav && nav.type !== 'navigate' ? null : `fresh-${Date.now()}`;
  } catch {
    return null;
  }
})();
const scrollKey = (loc: { key: string; pathname: string; search: string }) =>
  loc.key === 'default' ? FIRST_LOAD_KEY ?? `${loc.pathname}${loc.search}` : loc.key;

export function Layout() {
  const { pathname } = useLocation();
  const fullScreen =
    FULL_SCREEN_ROUTES.includes(pathname.replace(/\/+$/, '')) || pathname.startsWith('/messages');
  return (
    <div className="min-h-screen flex flex-col">
      {/* Back/forward returns to where the user was; new pages open at the top. */}
      {/* Every first page load has location.key "default", so the saved
          position of whatever page was open before (e.g. scrolled to the
          footer) was restored onto a different page opened by link/reload —
          «Тандалгандар» opened at the footer. Key first loads by URL instead. */}
      <ScrollRestoration getKey={scrollKey} />
      <ScrollToHash />
      <ScrollToTop />
      <GoogleOneTap />
      <AskNameDialog />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>

      {!fullScreen &&
        (APP_TAB_ROUTES.includes(pathname.replace(/\/+$/, '')) ? (
          // App-like tab on phones: no site footer under the list.
          <div className="hidden md:block">
            <Footer />
          </div>
        ) : (
          <Footer />
        ))}
      <ChatPopupHost />
    </div>
  );
}
